import { render, staticRenderFns } from "./CreateUpdateAnnualInstitutionObjectives.vue?vue&type=template&id=bc2ebff0"
import script from "./CreateUpdateAnnualInstitutionObjectives.vue?vue&type=script&lang=js"
export * from "./CreateUpdateAnnualInstitutionObjectives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports